const QUOTE_SUFFIXES = ["USDT", "IRT", "CAD"].sort(
  (a, b) => b.length - a.length
);

// Make requests to CryptoCompare API
export async function makeApiRequest(path) {
  try {
    const response = await fetch(`https://min-api.cryptocompare.com/${path}`);
    return response.json();
  } catch (error) {
    throw new Error(`CryptoCompare request error: ${error.status}`);
  }
}

// Generate a symbol ID from a pair of the coins
export function generateSymbol(exchange, fromSymbol, toSymbol) {
  const short = `${fromSymbol}${toSymbol}`;
  return {
    short,
    full: `${exchange}:${short}`,
  };
}

/**
 * Parse `exchange:BASEQUOTE` or bare `BASEQUOTE` into base/quote.
 * Quotes matched longest-first so USDT wins over shorter suffixes.
 */
export function parseFullSymbol(fullSymbol) {
  const raw = String(fullSymbol || "");
  const match = raw.match(/^(?:(\w+):)?(\w+)$/);
  if (!match) return null;

  const exchange = match[1] || null;
  const pair = match[2];

  for (const quote of QUOTE_SUFFIXES) {
    if (pair.endsWith(quote) && pair.length > quote.length) {
      return {
        exchange,
        fromSymbol: pair.slice(0, -quote.length),
        toSymbol: quote,
      };
    }
  }

  return null;
}
